"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allowedDateTimePropKeys = exports.EnumOptions = exports.CombinatorSchemaSwitcherOptions = void 0;
exports.isDateTimeControlOptions = isDateTimeControlOptions;
exports.CombinatorSchemaSwitcherOptions = [
    "button",
    "dropdown",
    "radio",
    "segmented",
];
exports.EnumOptions = ["dropdown", "radio", "segmented"];
/**
 * The input props of the AntD DatePicker component that we want to
 * expose to api consumers through schema options.  Full list of props
 * can be found in [this section](https://ant.design/components/date-picker#datepicker)
 * of the antd docs.
 */
exports.allowedDateTimePropKeys = [
    "id",
    "is",
    "alt",
    "size",
    "width",
    "style",
    "format",
    "height",
    "title",
    "presets",
    "showNow",
    "showHour",
    "showTime",
    "showWeek",
    "showMinute",
    "showSecond",
    "showMillisecond",
];
function isDateTimeControlOptions(options) {
    if (typeof options !== "object" || options == null) {
        return false;
    }
    for (const key of Object.keys(options)) {
        if (!exports.allowedDateTimePropKeys.includes(key)) {
            return false;
        }
    }
    return true;
}
var RuleEffect;
(function (RuleEffect) {
    /**
     * Effect that hides the associated element.
     */
    RuleEffect["HIDE"] = "HIDE";
    /**
     * Effect that shows the associated element.
     */
    RuleEffect["SHOW"] = "SHOW";
    /**
     * Effect that enables the associated element.
     */
    RuleEffect["ENABLE"] = "ENABLE";
    /**
     * Effect that disables the associated element.
     */
    RuleEffect["DISABLE"] = "DISABLE";
})(RuleEffect || (RuleEffect = {}));
